// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2lQjB","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2rtA5"};